import { render, staticRenderFns } from "./ProductsCompensation.vue?vue&type=template&id=ae412b46&"
import script from "./ProductsCompensation.vue?vue&type=script&lang=js&"
export * from "./ProductsCompensation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports